export default "__VITE_ASSET__BXZJhFN3__"